'use client'
import React, { createContext } from 'react'

export interface PublicCompetitionContextType {
  data: Record<string, unknown>
}

export const PublicCompetitionContext = createContext<
  PublicCompetitionContextType | undefined
>(undefined)

const PublicCompetitionProvider = ({
  data,
  children,
}: {
  data: Record<string, unknown>
  children: React.ReactNode
}) => {
  return (
    <PublicCompetitionContext.Provider
      value={{
        data: data,
      }}
    >
      {children}
    </PublicCompetitionContext.Provider>
  )
}

export default PublicCompetitionProvider
